import React, { Component } from 'react';
import {
  Image,
  ImageBackground,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  Button,
  View,
} from 'react-native';

import FirebaseUsers from '../firebase/firebase_users.js'
import Messaging from '../messaging.js';

import EonnTitle from '../components/title';
import EonnButton from '../components/button';
import EonnStars from '../components/stars';
import EonnLink from '../components/link';
import EonnField from '../components/field';
import { mstyles } from '../constants/MainStyles';

const styles = StyleSheet.create({
  topRow: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 15,
  },
  profileImage: {
    width: 100,
    height: 100,
    borderRadius: 50,
  },
  profileBox: {
    flex: 1,
    paddingLeft: 20,
  },
  profileTitle: {
    fontSize: 24,
    lineHeight: 26,
  },
  profileExp: {
    fontSize: 17,
    lineHeight: 19,
  },
  rate1: {
    fontSize: 20,
    lineHeight: 22,
  },
  rate2: {
    fontSize: 24,
    lineHeight: 26,
  },
  rateDollar: {
    fontSize: 19,
  },
  about: {
    fontSize: 16,
    paddingVertical: 15,
    paddingHorizontal: 35,
  },
  subtitle: {
    fontSize: 20,
    marginTop: 20,
  },
  text: {
    fontSize: 16,
  }
});


export default class Screen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showRequired: false,
      err: "",
    };
    console.log(global.user);
    
  }

  render() {
    return (
      <ScrollView style={mstyles.sContainer} contentContainerStyle={mstyles.sContent}>

        <View style={styles.topRow}>
          <Image source={{uri: global.user.profilePicture}} style={styles.profileImage} />

          <View style={styles.profileBox}>
            <Text style={[mstyles.mfont,styles.profileTitle]}>{global.user.name || ""}</Text>
            <Text style={[mstyles.mfont,styles.profileExp]}>Experience: {global.user.experience || ""} Years</Text>
            <EonnStars stars={4}>15</EonnStars>
          </View>
        </View>
        <Text style={[mstyles.mfont,styles.rate1]}>Price Per Consultation</Text>
        <Text style={[mstyles.mfont,styles.rate2]}><Text style={styles.rateDollar}>$</Text>{global.user.rate || ""}</Text>
        <Text style={[mstyles.mfont,styles.about]}>{global.user.about || ""}</Text>
        <Text style={[mstyles.mfont,styles.subtitle]}>Vehicle Specialization</Text>
        {global.user.expertise?.map((type,i) =>
          <Text style={[mstyles.mfont,styles.text]} key={i}>{type}</Text>
        )}
        <Text style={[mstyles.mfont,styles.subtitle]}>Repair Specialization</Text>
        {global.user.specializations?.map((type,i) =>
          <Text style={[mstyles.mfont,styles.text]} key={i}>{type}</Text>
        )}
        <Text style={[mstyles.mfont,styles.subtitle]}>Completed Virtual Consultations</Text>
        <Text style={[mstyles.mfont,styles.text]}>{global.user.completedConsults || 0}</Text>

        <EonnButton
          navigationProps={this.props.navigation}
          loading={this.state.loading}
          onPress={async () => {
            try {
              this.setState({ loading: true });
              // Ensure profile picture is uploaded if local
              if (global.user.profilePicture && !/^https?:\/\//i.test(global.user.profilePicture)) {
                try {
                  const downloadURL = await FirebaseUsers.uploadProfilePicture(global.user.profilePicture);
                  global.user.profilePicture = downloadURL;
                } catch (e) {
                  // proceed even if upload fails; a default is already shown elsewhere
                }
              }
              // Create auth user now, using password saved during step 2
              const pw = (global.techSignup && global.techSignup.password) || '';
              if (!pw) {
                throw new Error('Missing signup password. Please restart signup.');
              }
              await FirebaseUsers.signUp(pw);
              delete global.user.password;
              if (global.techSignup) delete global.techSignup.password;
              await FirebaseUsers.updateUserInfo();
              // Welcome notifications
              try {
                await Messaging.sendEmail(
                  global.user.email,
                  "Welcome to Auto Teletech",
                  "Welcome to Auto Teletech! Thank you for signing up.",
                  `
                  <p>Hi, ${global.user.name || ''},</p>
                  <p>Welcome to Auto Teletech! You're now part of a growing network of professional automotive technicians offering paid video consultations.</p>
                  <p>Next steps:</p>
                  <p>1. Log in to your dashboard</p>
                  <p>2. Connect your Stripe account if you haven't already</p>
                  <p>Get ready to start earning by offering your expert advice!</p>
                  <p>Log in now at <a href="https://consult.autoteletech.com/?side=tech">consult.autoteletech.com/?side=tech</a></p>
                  <p>Let's get started!</p>
                  <p>The Auto Teletech Team</p>
                  <a href="https://www.autoteletech.com">Auto Teletech</a>
                  `
                );
              } catch (e) {}
              try {
                await Messaging.sendSMS(
                  global.user.phone,
                  "Auto TeleTech: Welcome to the family! To begin accepting consultations, set up your Stripe payouts in your dashboard."
                );
              } catch (e) {}
              this.props.navigation.navigate("T_Home");
            } catch (err) {
              this.setState({ err: err.message || String(err) });
            } finally {
              this.setState({ loading: false });
            }
          }}
          >
          Finish</EonnButton>
      </ScrollView>
    );
  }
}